export class Impressora {
    id?: number;
    dominio?: string;
    nome?: string;
    tipo?: string;	
    rota?: string;
    caixa_alta?: string;
    cod?: string;
    tempo?: string;
    copias?: string;
    tamanho?: string;
}